var ___EXPOSE_LOADER_IMPORT___ = require("-!../node_modules/ts-loader/index.js!../node_modules/minify-html-literals-loader/index.js!./index.ts");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
var ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___ = ___EXPOSE_LOADER_IMPORT___.default
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["gmfapi"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["gmfapi"] = ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
